<script>
    import { createEventDispatcher } from 'svelte';
    import Icon from '../icons/Icon.svelte';

    export let show = false;
    export let selectedTable = null;
    export let tables = [];
    export let transferTargetId = '';

    const dispatch = createEventDispatcher();

    function handleClose() {
        dispatch('close');
    }

    function handleSubmit() {
        if (!transferTargetId) return;
        dispatch('submit', { transferTargetId });
    }

    $: availableTables = tables.filter(t => t.status === 'available' && (!selectedTable || t.id !== selectedTable.id));
</script>

{#if show && selectedTable}
    <div class="modal-overlay" on:click|self={handleClose}>
        <div class="modal-card">
            <div class="modal-header">
                <h3>Transferir {selectedTable.label}</h3>
                <button class="close-btn" on:click={handleClose} type="button">
                    <Icon name="x" size={16} />
                </button>
            </div>
            <div class="modal-body">
                <p class="description">
                    Selecione a nova mesa disponível para onde deseja mover os pedidos e clientes.
                </p>
                <div class="field">
                    <label for="target-table">Mesa de Destino:</label>
                    <select id="target-table" bind:value={transferTargetId}>
                        <option value="">Selecione uma mesa livre...</option>
                        {#each availableTables as t}
                            <option value={t.id}>{t.label} ({t.seats} lugares)</option>
                        {/each}
                    </select>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn-cancel" on:click={handleClose} type="button">Cancelar</button>
                <button class="btn-primary" on:click={handleSubmit} disabled={!transferTargetId} type="button">
                    Confirmar Troca de Mesa
                </button>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(2px);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        overflow-y: auto;
        box-sizing: border-box;
        z-index: 9999;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        width: 100%;
        max-width: 480px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-sizing: border-box;
        padding: 24px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }

    .modal-header h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 800;
        color: #0F172A;
    }

    .close-btn {
        background: transparent;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 4px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.15s, color 0.15s;
    }

    .close-btn:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 24px;
    }

    .description {
        color: #64748B;
        font-size: 13px;
        line-height: 1.5;
        margin: 0;
    }

    .field {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .field label {
        font-size: 13px;
        font-weight: 600;
        color: #334155;
    }

    .field select {
        height: 42px;
        padding: 0 12px;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        font-size: 14px;
        color: #0F172A;
        background: #FFFFFF;
        outline: none;
        transition: border-color 0.15s, box-shadow 0.15s;
        box-sizing: border-box;
    }

    .field select:focus {
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
    }

    .btn-cancel {
        height: 38px;
        padding: 0 16px;
        border: 1px solid #E2E8F0;
        background: #FFFFFF;
        color: #64748B;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.15s, color 0.15s;
    }

    .btn-cancel:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .btn-primary {
        height: 38px;
        padding: 0 18px;
        border: none;
        background: #FF6A00;
        color: #FFFFFF;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(255, 106, 0, 0.25);
        transition: background 0.15s, transform 0.05s;
    }

    .btn-primary:hover:not(:disabled) {
        background: #EA580C;
    }

    .btn-primary:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
    }

    .btn-primary:active:not(:disabled) {
        transform: scale(0.98);
    }
</style>
